import { defineComponent as _defineComponent } from 'vue'
import { IProductHero } from '@/modules/catalog/services/products';
import InstrumentAvatar from '@/modules/trade/components/InstrumentAvatar/InstrumentAvatar.vue';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  ButtonPrimary,
  Heading,
  SpinnerLoader
} from '@warrenbrasil/nebraska-web';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSideSheetHero',
  props: {
  showHeaderText: Boolean,
  color: {
    type: String,
    default: ''
  },
  hero: {
    type: Object as PropType<IProductHero>,
    default: null
  },
  loading: Boolean,
  error: Boolean
},
  emits: ['retry'],
  setup(__props, { emit }) {

const props = __props;





return { __sfc: true,props, emit, InstrumentAvatar, NebraskaColors, BaseText, ButtonPrimary, Heading, SpinnerLoader }
}

})